import { Box, Button, DialogActions, DialogContent, DialogTitle, Grid, SelectChangeEvent, Typography } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector, } from "../../store/hooks";
// import styles from './DialogBankForm.module.css';

import { fetchBankById, addBank, updateBank } from '../../store/bankStore/bankThunk';
import { fetchCurrencies } from '../../store/currencyStore/currencyThunk';
import { fetchCountries } from '../../store/countryStore/countryThunk';
import CustomTextField from '../FormFields/CustomTextField';
import CustomSelect, { IOptions } from '../FormFields/CustomSelect';
import { FormProvider, useForm } from 'react-hook-form';
import { IBankFormInputs } from '../../utils/bank.types';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { ApiStatus } from '../../utils/api.types';
import LoadingButton from '@mui/lab/LoadingButton';

interface DialogBankFormProps {
  title?: string;
  bankId?: string;
  open: boolean;
  onClose: (k: any) => void;
}

const DialogBankForm: FC<DialogBankFormProps> = ({ title, onClose, bankId, open, children }) => {

  const dispatch = useAppDispatch();
  const params = useParams();
  const [countryOptions, setCountryOptions] = useState<IOptions[]>([]);
  const [bankCountry, setBankCountry] = useState('');
  const [currencyOptions, setCurrencyOptions] = useState<IOptions[]>([]);
  const [bankCurrency, setBankCurrency] = useState('');
  const [bankData, setBankData] = useState();
  // const [legalName, setLegalName] = useState('');
  const { selectedAccount } = useAppSelector(state => state.auth);

  // Schema to validate account form.
  const schema = yup.object().shape({
    bankName: yup.string().required("Bank name is required."),
    branchName: yup.string().required("Branch name is required."),
    country: yup.string().required("Country is required."),
    IFSC: yup.string().required("IFSC is required."),
    currency: yup.string().required("Currency is required."),
    accountNumber: yup.string().required("Account number is required."),
    accountName: yup.string().required("Account name is required.")
  });
  //form
  const methods = useForm<IBankFormInputs>({ mode: 'onTouched', resolver: yupResolver(schema) });

  const { status } = useAppSelector(state => state.banks);

  useEffect(() => {
    const getBankDetails = async () => {
      if (bankId) {
        const bd: any = await dispatch(fetchBankById(bankId));

        setBankData(bd.payload);

        methods.setValue('accountName', bd.payload.accountName);
        methods.setValue('accountNumber', bd.payload.accountNumber);
        methods.setValue('bankName', bd.payload.bankName);
        methods.setValue('branchName', bd.payload.branchName);
        methods.setValue('country', bd.payload.country?._id);
        methods.setValue('IFSC', bd.payload.IFSC);
        methods.setValue('currency', bd.payload.currency._id);
        methods.setValue('SWIFT', bd.payload.SWIFT);
        methods.setValue('MICR', bd.payload.MICR);
        methods.setValue('IBAN', bd.payload.IBAN);
        setBankCountry(bd.payload.country?._id);
        setBankCurrency(bd.payload.currency?._id);
      }
      // } else {
      //   methods.setValue('accountName', selectedAccount.legalName || '');
      // }
    }

    getBankDetails();
  }, [bankId, dispatch, methods, selectedAccount]);

  useEffect(() => {
    const getCurrencies = async () => {
      if (!currencyOptions.length) {
        const data: any = await dispatch(fetchCurrencies());

        setCurrencyOptions(data.payload.map((c: any) => {
          return { label: c.code, value: c._id }
        }));
      }
    }

    if (open) {
      getCurrencies();
    }
  }, [open, currencyOptions, dispatch]);

  useEffect(() => {
    const getCountries = async () => {
      if (!countryOptions.length) {
        const data: any = await dispatch(fetchCountries());

        setCountryOptions(data.payload.map((c: any) => {
          return { label: c.name, value: c._id }
        }));
      }
    }

    if (open) {
      getCountries();
    }

  }, [open, dispatch, countryOptions]);;

  const updateBankDetails = async (e: any) => {
    if (bankId) {
      const resData: any = await dispatch(updateBank({
        bankPayload: e,
        id: bankId
      }));

      if (!resData.error) {
        onClose(true);
      }
    }
  }
  const createBankDetails = async (e: any) => {
    const resData:any = await dispatch(addBank({ ...e, ...{ account: params.accountId } }));
    
    if (!resData.error) {
      onClose(true);
    }
  }

  const onSubmit = (e: any) => {
    if (bankId) {
      updateBankDetails(e);
      return;
    }

    createBankDetails(e);
  }

  return (
    <div className="drawer-form-container">
      <FormProvider {...methods}>
        {(!bankId || (bankId && bankData)) &&
          <Box
            sx={{ display: "flex", flexDirection: "column", height: "100vh", padding: "16px 0 16px 16px" }}
            component="form"
            onSubmit={methods.handleSubmit(onSubmit)}
            noValidate>
            <DialogTitle sx={{ height: "0px", mt: 1, mb: 1, justifyContent: "space-between" }}>
              <Box >
                <Typography variant="h5">{bankId ? 'Update Bank Details' : 'Add Bank Details'}</Typography>
              </Box>
            </DialogTitle>

            <DialogContent>
              <Grid container justifyContent="center" spacing={2} rowSpacing={-2}>
                <Grid item xs={12} md={12} sm={12} lg={12}>
                  <CustomTextField label="Account Name*" name="accountName" variant="standard" />
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12}>
                  <CustomTextField label="Account Number*" name="accountNumber" variant="standard" />
                </Grid>

                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
                  <CustomTextField label="Bank Name" name="bankName" required variant="standard" />
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12}>
                  <CustomTextField label="Branch Name" name="branchName" required variant="standard" />
                </Grid>

                <Grid item xs={12} md={12} sm={12} lg={12}>
                  {countryOptions?.length && <CustomSelect
                    name="country"
                    label="Country*"
                    id="country"
                    variant="standard"
                    required
                    options={countryOptions}
                    value={bankCountry ?? ''}
                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue("country", event.target.value, { shouldValidate: true });
                      setBankCountry(event.target.value);
                    }} />}
                </Grid>

                <Grid item xs={12} md={12} sm={12} lg={12} sx={{ pt: '0px' }}>
                  <CustomTextField label="IFSC" name="IFSC" required variant="standard" />
                </Grid>
                <Grid item xs={12} md={12} sm={12} lg={12}>
                  {currencyOptions?.length && <CustomSelect
                    name="currency"
                    label="Currency*"
                    id="currency"
                    variant="standard"
                    required
                    options={currencyOptions}
                    value={bankCurrency ?? ''}
                    onChange={(event: SelectChangeEvent<any>) => {
                      methods.setValue("currency", event.target.value, { shouldValidate: true });
                      setBankCurrency(event.target.value);
                    }} />}
                </Grid>

                <Grid item xs={12} md={12} sm={12} lg={12}>
                  <CustomTextField label="SWIFT" name="SWIFT" variant="standard" />
                  <CustomTextField label="MICR" name="MICR" variant="standard" />
                  <CustomTextField label="IBAN" name="IBAN" variant="standard" />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions sx={{ height: "40px", mb: 2 }}>
              <Grid container gap='0' sx={{ mr: '32px', pt: '10px' }}>
                <Grid item xs={12} md={12} sm={12} lg={12} display="flex" justifyContent="flex-end" >
                  <Button variant='outlined'
                    style={{ marginRight: '10px' }}
                    onClick={() => {
                      methods.reset();
                      onClose(false);
                    }}>Cancel</Button>
                  <LoadingButton
                    type="submit"
                    // disabled={!methods.formState.isValid}
                    loading={status === ApiStatus.LOADING}
                    variant="contained"
                  >
                    {bankId ? 'Update' : 'Create'}
                  </LoadingButton>
                </Grid>
              </Grid>
            </DialogActions>
          </Box>}
      </FormProvider>
    </div >
  );
};

export default DialogBankForm;
